const SAPH_SPONSORS = [

   // {
   //     name: "Nexus Investments",
  //      imagePath: '/assets/nexus.png',
  //      shortDesc: "Nexus Investments LLC, Community of Stock Market Traders",
  //      longDesc: `Nexus Investments LLC is the ultimate trading & investing community.
   //     We primarily trade Stock Options but also trade Stocks, Futures, & Forex.
   //     We use software systems that utilize Artificial Intelligence.
  //      We have giveaways, referral bonuses, education, bot integrations, & more.
  //      Join now & learn how to earn a free membership!`,
  //      discordURL: 'https://discord.gg/HwmsPkR',
  //      vertURL: 'https://discord.gg/HwmsPkR',
  //      key: 'saph-one'
  //  },
  //  {
 //       name: "J&M Option Trading",
 //       imagePath: '/assets/jmlogo.png',
 //       shortDesc: "J&M Option Trading Community; free trading resources for everyone!",
 //       longDesc: `Learn more about our educational trading community,
 //           with tools and resources for all traders! Our team of analysts
 //           and educators are here for you 100% of the way, no matter where
//            you are in your trading career. Join our server today for free trade alerts,
 //           chart analysis, and trading recaps.`,
 //       discordURL: 'https://discord.gg/mV7FNUa',
 //       vertURL: 'https://discord.gg/mV7FNUa',
 //       key: 'saph-one'
 //   },
    //{
    //    name: "MD Live",
    //    imagePath: '/assets/mdllogo1.png',
    //    shortDesc: "A Trading family focused on your growth!",
    //    longDesc: `A trading community focused on growing your knowledge so you can grow your wealth.
    //    Voice channels with live trading and Q&A, monthly cash prizes, stock & options alerts, & more.
    //    Join a real trading FAMILY! 10 days free trial and 10% off with code : OFBFTW`,
    //    discordURL: 'https://discord.gg/MeUxstN',
    //    vertURL: 'https://discord.gg/MeUxstN',
    //    key: 'saph-two'
    //},
    //{
    //    name: "Tradytics",
    //    imagePath: '/assets/tradytics-2.png',
    //    shortDesc: "Artificial intelligence trade ideas for retail traders",
    //    longDesc: `Comprehensive trading toolkit - Live Options Flow - AI Signals - Technical Analysis - Scanners - Portfolios - Social Media Chatters - Analysis Tools, and more.`,
    //    discordURL: 'https://www.tradytics.com/?ref_link=optionsfambottradyticsreferral',
    //    vertURL: 'https://www.tradytics.com/?ref_link=optionsfambottradyticsreferral',
    //    key: 'saph-three'
    //},
    {
        name: "HighShorts",
        imagePath: '/assets/highshort-transparent.png',
        shortDesc: "High Short Interest Stock Information",
        longDesc: `HighShorts is a collection of data relating to High Short Interest stocks, WallStreetBets (WSB), StockTwits, and Discord activity.`,
        discordURL: 'https://highshorts.com',
        vertURL: 'https://highshorts.com',
        key: 'saph-one'
    },
    {
        name: "OptionsFamBot",
        imagePath: '/assets/ofbcircle.png',
        shortDesc: "High Quality Market Data for a fraction of the cost",
        longDesc: `OptionsFamBot strives to deliver the best market data at the lowest cost for the end user. We deliver data from Dark Pools to Options and everything in between.`,
        discordURL: 'https://discord.gg/Q9eU4QS',
        vertURL: 'https://optionsfambot.com',
        key: 'saph-two'
    },
 //   {
 //       name: "BlackBox",
 //       imagePath: '/assets/bbslogosquare2.png',
 //       shortDesc: "Live options flow * algo based options and stock alerts",
 //       longDesc: `Live options flow * algo based options and stock alerts * moderator plays * private discord server.
 //       Training and screenshares provided weekly. News feed from the fly included. Free trials and annual discounts available.
 //       Join the best group of daytraders in the business!`,
 //       discordURL: 'https://discord.gg/yrvsgX4',
 //       vertURL: 'https://discord.gg/yrvsgX4',
 //       key: 'saph-two'
 //   },


]

const GOLD_SPONSORS = [
    {
        name: "Your Server Here",
        imagePath: '/assets/your-logo.png',
        longDesc: `Contact andrew.kenreich@gmail.com`,
        discordURL: 'https://discordapp.com/api/oauth2/authorize?client_id=452988914215550997&scope=bot&permissions=522310',
        key: 'gold-one'
    }
]

const IRON_SPONSORS = [
    {
        name: "Your Server Here",
        imagePath: '/assets/your-logo.png',
        discordURL: 'https://discordapp.com/api/oauth2/authorize?client_id=452988914215550997&scope=bot&permissions=522310',
        key: 'iron-one'
    },

    {
        name: "Your Server Here",
        imagePath: '/assets/your-logo.png',
        discordURL: 'https://discordapp.com/api/oauth2/authorize?client_id=452988914215550997&scope=bot&permissions=522310',
        key: 'iron-two'
    }
]

// From: https://stackoverflow.com/a/19270021/5266445
function getRandom(arr, n) {
    let result = new Array(n),
        len = arr.length,
        taken = new Array(len);
    if (n > len){
        throw new RangeError("getRandom: more elements taken than available")
    }

    while (n--) {
        let x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
}

export default {
    tiers: {
        saph: SAPH_SPONSORS,
        gold: GOLD_SPONSORS,
        iron: IRON_SPONSORS
    },

    random: getRandom
}